import React, { useEffect, useRef } from "react";

const SRC =
  "https://www.opentable.com/widget/reservation/loader?rid=54415&type=standard&theme=wide&color=1&dark=false&iframe=true&domain=com&lang=en-US&newtab=false&ot_source=Restaurant%20website&cfe=true";

export default function OpenTableWidget() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = "";
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = SRC;
    // If the loader script is blocked, embed the booking form iframe directly
    const fallback = () => {
      if (el.querySelector("iframe")) return;
      el.innerHTML = `<iframe title="OpenTable reservation booking form" src="${SRC.replace("/loader?", "/canvas?")}" width="840" height="350" style="border:0;max-width:100%" loading="lazy"></iframe>`;
    };
    script.onerror = fallback;
    const timer = setTimeout(fallback, 6000);
    el.appendChild(script);
    return () => { clearTimeout(timer); el.innerHTML = ""; };
  }, []);

  return (
    <div
      ref={ref}
      className="w-full min-h-[300px] flex justify-center overflow-x-auto [&_iframe]:max-w-full"
      aria-label="OpenTable reservation booking form"
      role="region"
    />
  );
}